import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { Tabs } from '../elements-buttons/tab-buttons';
import { PlaceholderWithBtn } from '../elements-placeholder/placeholder';
import { ProjectInfoBox } from './project-info-box';
import { ProjectsModalFlow } from '../flow-projects/projects-modal';
import { FormattedMessage, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

class ProjectMain extends Component {
  constructor (props) {
    super(props);

    this.renderShareButton = this.renderShareButton.bind(this);
    this.openInviteModal = this.openInviteModal.bind(this);
  }

  openInviteModal (project) {
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <ProjectsModalFlow
          project={project}
          inviteSave={this.props.inviteSave}
          inviteSaveCb={this.props.inviteSaveCb}
          modalType={'share'}
          openModal={ this.openInviteModal }
          analyticsOrigin={ 'boards thumbnail' }
          closeModal={this.props.closeModal}
        />
      </SharedIntlProviderHOC>,
      document.getElementById('modal-container')
    );
  }

  renderShareButton (project) {
    return (
      <div className="text-right">
        <ul
          role="button"
          className="list-inline email-share-btn"
          onClick={
            (e) => {
              e.preventDefault();
              return this.openInviteModal(project);
            }
          }
          aria-pressed="false"
          tabIndex="0"
        >
          <li className="ico-md icon-mail-outline v-center"></li>
          <li className="v-center save-text">
            <FormattedMessage
              id="boards.project_main.invite"
              defaultMessage="Invite"
            />
          </li>
        </ul>
      </div>
    );
  }

  render () {
    const { route, projects } = this.props;
    const projectsArray = _.orderBy(projects, ['modified'], ['desc']) || [];
    const location = route.path;
    const tabs = [
      {
        label: this.props.intl.formatMessage({ id: 'boards.project_main.all_boards', defaultMessage: 'All Boards ({count})' }, { count: projectsArray.length }),
        link: 'projects',
        name: 'projects'
      }
    ];

    return (
      <div className='projects-container ps-container-lg-margin'>
        <div className='ps-row'>
          <div className='col-xs-12 '>
            <Tabs tabs={tabs} loc={location} />
          </div>
        </div>
        <div className='search-thumbnails ps-row'>
          {projectsArray.length ? (
            projectsArray.map((project, i) => (
              <div key={`project-board-${i}`} className='col-xs-12 col-md-4'>
                <a
                  className='listing-thumbnails'
                  ref='listingThumbnail'
                  target='_blank'
                  href={`/boards/${project?.external_id}`}
                >
                  <ProjectInfoBox
                    project={project}
                    CTA={() => {
                      return this.renderShareButton(project);
                    }}
                  />
                </a>
              </div>
            ))
          ) : (
            <div className='col-xs-12'>
              <PlaceholderWithBtn
                icon='icon-full-heart'
                text={this.props.intl.formatMessage({
                  id: 'boards.project_main.dont_have_boards',
                  defaultMessage:
                    "You don't have any boards yet. Save a space to get started."
                })}
                link='/'
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(ProjectMain);
